module.exports = __webpack_public_path__ + "img/archived.fd584974.svg";